export default async function HoldTaskApi(taskId, holdReason, blockedTaskIds = []) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ holdReason, blockedTaskIds }),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/tasks/${taskId}/hold`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error holding task: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
